import { CapoPlugin } from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];